// extracted by mini-css-extract-plugin
export default {"userinvite":"Userinvite_userinvite__z7JnS","inviteform":"Userinvite_inviteform__z1DHU","form":"Userinvite_form__dDOpK"};